module.exports = __webpack_public_path__ + "static/media/bug.dd5a6ac8.png";